import { cropIds } from 'constants/crops';

/**
 * Parse validation file for value matching user's unit template
 * @param {Array} data
 * @param {String} unitsOfMeasureTemplate
 * @return {*}
 */
export const getValueByUnit = (data, unitsOfMeasureTemplate) => {
  const value = data.find(item => item.type === unitsOfMeasureTemplate);
  return value || data.find(item => item.type === 'imperial');
};

const usCanadaValidationValues = [{
  min: 0,
  max: 1000,
  unit: 'lbs/ac',
  type: 'si'
}, {
  min: 0,
  max: 1000,
  unit: 'gal/ac',
  type: 'imperial'
}];

export const parseProductValidationValues = ( rawProductValidationValues, unitsOfMeasureTemplate ) => {
  return Object.keys(rawProductValidationValues).reduce(() => {
    return {
      COUNTRY: rawProductValidationValues.country,
      PLANTING:{
        CORN:{
          CROP_ID: cropIds.CORN,
          BAG_SIZE: rawProductValidationValues.planting.corn['bag-size'],
          RATE: getValueByUnit(rawProductValidationValues.planting.corn.rate, unitsOfMeasureTemplate),
          TARGET_YIELD:
            getValueByUnit(rawProductValidationValues.planting.corn['target-yield'], unitsOfMeasureTemplate),
          SEED_COST: rawProductValidationValues.planting.corn['seed-cost'],
          GRAIN_PRICE: rawProductValidationValues.planting.corn['grain-price'],
          RM: {
            min: 80,
            max: 120
          }
        },
        SOYBEANS:{
          CROP_ID: cropIds.SOYBEAN,
          BAG_SIZE: rawProductValidationValues.planting.soybeans['bag-size'],
          RATE: getValueByUnit(rawProductValidationValues.planting.soybeans.rate, unitsOfMeasureTemplate),
          TARGET_YIELD:
            getValueByUnit(rawProductValidationValues.planting.soybeans['target-yield'], unitsOfMeasureTemplate),
          RM: {
            min: 0,
            max: 7,
            step: 0.1
          }
        }
      },
      FERTILITY:{
        LPK:{
          DRY:{
            RATE: getValueByUnit(rawProductValidationValues.fertility.lpk.dry.rate, unitsOfMeasureTemplate)
          },
          WET:{
            RATE: getValueByUnit(rawProductValidationValues.fertility.lpk.wet.rate, unitsOfMeasureTemplate)
          }
        },
        NITROGEN:{
          DRY:{
            RATE: getValueByUnit(rawProductValidationValues.fertility.nitrogen.dry.rate, unitsOfMeasureTemplate)
          },
          WET:{
            RATE: getValueByUnit(rawProductValidationValues.fertility.nitrogen.wet.rate, unitsOfMeasureTemplate)
          }
        },
        FERTILIZER: {
          RATE: {
            min: 0,
            max: 1000
          }
        }
      },
      APPLICATION:{
        LPK:{
          DRY:{
            RATE: getValueByUnit(rawProductValidationValues.application && rawProductValidationValues.application.lpk
              ? rawProductValidationValues.application.lpk.dry.rate : usCanadaValidationValues, unitsOfMeasureTemplate)
          },
          WET:{
            RATE: getValueByUnit(rawProductValidationValues.application && rawProductValidationValues.application.lpk
              ? rawProductValidationValues.application.lpk.wet.rate : usCanadaValidationValues, unitsOfMeasureTemplate)
          }
        },
        APPLICATION: {
          RATE: {
            min: 0,
            max: 1000
          }
        }
      }
    };
  }, {});
};
